import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UsuarioService  } from '../services/service.index';
import Swal2 from 'sweetalert2';
import { RolesService } from '../services/roles/roles.service';
import { NgForm } from '@angular/forms';
@Component({
  selector: 'app-loginGFC',
  templateUrl: './loginGFC.component.html',
  styleUrls: ['./loginGFC.component.css']
})
export class LoginGfcComponent implements OnInit {
  showPassword = false;
  focus;
  focus1;
  roloptions: any[] = [];
  recuperacont = false;

  constructor(public router: Router,
              private usuarioservice: UsuarioService,
              private rolesService: RolesService) { }

  ngOnInit() {
    if (localStorage.getItem('rid')) {
      this.redirecciona();
    }

  }

  login() {
    Swal2.showLoading()
    const correo = (document.getElementById('correo') as HTMLInputElement).value;
    const pass = (document.getElementById('password') as HTMLInputElement).value;
    this.usuarioservice.login( correo, pass ).subscribe( async resp => {
    if ( resp.data.attributes.status !== 'AC' ) {
        //Swal2.close();
        Swal2.fire(
        'El usuario no se encuentra activo',
        '',
        'error'
     );
      } else {
        localStorage.setItem('uid', resp.data.attributes.id );
        localStorage.setItem('tkn', resp.data.token );
        localStorage.setItem('emailuser', resp.data.attributes.email );
        localStorage.setItem('nombreuser', resp.data.attributes.name );
        localStorage.setItem('expiratoken', resp.data.expires_at);
        localStorage.setItem('firmante', resp.data.attributes.company_signatory);
        if(resp.data.attributes.role_id != null){
          localStorage.setItem('rid', resp.data.attributes.role_id);
          this.redirecciona();
        }else{
          Swal2.fire('Datos incompletos', 'Comuníquese con el administrador', 'info');
        }
      }
    }, (err) => {             console.clear();
     // Swal2.close();
      Swal2.fire(
        'Error al acceder',
        'Revise su información',
        'error'
     );
  }
   );
  }

  redirecciona() {
      this.rolesService.getRol(localStorage.getItem('rid')).subscribe(resp => {
        console.log(resp[0].name);
        if(resp[0].name === 'SuperAdmin'){
          this.router.navigate(['/panelcontrol/aprobarCreditos']);
        }else if(resp[0].name === 'Clientes'){
          this.usuarioservice.getCustomerxidu(localStorage.getItem('uid')).subscribe(r => {
            if (r.length > 0) {
              this.router.navigate([`/maincliente/solicitudcredito`]).then( () => {
              //  window.location.reload();
              });
            } else {
              this.router.navigate([`/registroemp`]).then( () => { 
              //  window.location.reload() 
              } )
            }
          })
        }
        else if(resp[0].name === 'Vendedor Yucatán' || resp[0].name === 'Vendedor Gobierno'){
          this.router.navigate(['/panelcontrol/empleadosGobierno']);
        }else{
          this.router.navigate(['/panelcontrol/aprobarCreditos/mesaControl']);
        }
      }, err => {
        console.log('error', err);
        window.location.reload();
      });

    }

  recuperarcont() {
    this.recuperacont = !this.recuperacont;
  }

  enviacrecuperacion() {
    const email = (document.getElementById('emailrec') as HTMLInputElement).value;
    if (!this.esCorreoValido(email)) {Swal2.fire('Correo electronico no valido','Revise su información','error'); return}
    this.usuarioservice.getResetPaswword(email).subscribe( resp => { this.recuperacont = !this.recuperacont;  console.log(resp);
                                                                      Swal2.fire(
        'El correo de recuperacion de contraseña fue enviado a:',
        email,
        'success'
     );
    }, (err) => {
      console.log(err);
      Swal2.fire(
           'Error',
           err.error.errors[0],
           'error'
        );
     } );
  }

  clicPass(){
    var x = (document.getElementById("password") as HTMLInputElement);
    if (x.type === "password") {
      x.type = "text";
    } 
  }

  liftPass(){
    var x = (document.getElementById("password") as HTMLInputElement);
    if (x.type === "text") {
      x.type = "password";
    } 
  }

  esCorreoValido(email: string): boolean {
  const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regexEmail.test(email);
}

}
